'use strict';

/*@ngInject*/
module.exports = function ($translateProvider, isDebug, supportedLanguages) {
    $translateProvider.registerAvailableLanguageKeys(supportedLanguages);

    var isLanguageInArray = function (value, array) {
        if (!value || !array) {
            return;
        }

        value = value.toLowerCase();
        value = value.replace('_', '-');
        if (array.indexOf(value) >= 0) {
            return value;
        }
        else if (value.length > 2) {
            value = value.substring(0, 2);
            if (array.indexOf(value) >= 0) {
                return value;
            }
        }
        else {
            return;
        }
    };

    // gets preferred language from browser
    $translateProvider.uniformLanguageTag('bcp47').determinePreferredLanguage(function () {
        if (navigator !== undefined && navigator !== null) {
            var language = isLanguageInArray(navigator.language, supportedLanguages);
            if (language) {
                return language;
            }

            if (navigator.languages !== undefined &&
                navigator.languages !== null &&
                navigator.languages instanceof Array) {
                language = isLanguageInArray(navigator.languages[0], supportedLanguages);
                if (language) {
                    return language;
                }
            }

            language = isLanguageInArray(navigator.browserLanguage, supportedLanguages);
            if (language) {
                return language;
            }

            language = isLanguageInArray(navigator.systemLanguage, supportedLanguages);
            if (language) {
                return language;
            }

            language = isLanguageInArray(navigator.userLanguage, supportedLanguages);
            if (language) {
                return language;
            }
        }
        return 'en';
    });

    $translateProvider.useStaticFilesLoader({
        prefix: 'locales/',
        suffix: '/translation.json'
    });

    if (!isDebug) {
        $translateProvider.useLocalStorage();
    }
    $translateProvider.useSanitizeValueStrategy('escaped');
    $translateProvider.useMissingTranslationHandler('customTranslateErrorHandler');
};